import script from "./ModalButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalButtons.vue?vue&type=script&setup=true&lang=js"

import "./ModalButtons.vue?vue&type=style&index=0&id=c0de7632&lang=css"

const __exports__ = script;

export default __exports__